export const TERMS_AND_CONDITIONS = {
  title: "Contrat d'utilisation de l'application mobile",
  desc: 'Ce contrat d\'utilisation (le "Contrat") est établi entre l\'utilisateur (l\'"Utilisateur") et "Les Assurances Bleues" (la "Société"), responsable de l\'application mobile nommée "cnarsugu" (l\'"Application"). En acceptant les termes de ce Contrat, l\'Utilisateur accepte de se conformer à toutes les conditions énoncées ci-dessous.',
  content: [
    {
      id: 2,
      title: "1. Acceptation des conditions",
      desc: "En téléchargeant, installant ou utilisant l'Application, l'Utilisateur reconnaît avoir lu, compris et accepté les termes et conditions de ce Contrat. Si l'Utilisateur n'est pas d'accord avec l'une des clauses de ce Contrat, il ne doit pas télécharger, installer ou utiliser l'Application.",
    },
    {
      id: 3,
      title: "2. Licence d'utilisation",
      desc: "La Société accorde à l'Utilisateur une licence personnelle, non exclusive, non transférable et révocable pour utiliser l'Application, conformément aux conditions énoncées dans ce Contrat. L'Utilisateur ne doit pas copier, modifier, distribuer ou vendre l'Application ou son contenu sans l'autorisation écrite préalable de la Société.",
    },
    {
      id: 4,
      title: "3. Restrictions d'utilisation",
      desc: "L'Utilisateur s'engage à n'utiliser l'Application que conformément aux lois et réglementations en vigueur et à ne pas :\n\na) Utiliser l'Application à des fins illégales, frauduleuses ou nuisibles.\nb) Contourner ou tenter de contourner les mesures de sécurité de l'Application.\nc) Utiliser l'Application pour collecter des informations personnelles d'autres utilisateurs sans leur consentement.\nd) Interférer avec le bon fonctionnement de l'Application ou perturber les serveurs ou réseaux connectés à celle-ci.\ne) Utiliser l'Application d'une manière qui puisse endommager, désactiver, surcharger ou altérer l'Application.",
    },
    {
      id: 5,
      title: "4. Propriété intellectuelle",
      desc: "Tous les droits de propriété intellectuelle relatifs à l'Application (y compris, mais sans s'y limiter, les droits d'auteur, les marques commerciales et les secrets commerciaux) sont la propriété exclusive de la Société. L'Utilisateur reconnaît que l'utilisation de l'Application ne lui confère aucun droit de propriété sur celle-ci.",
    },
    {
      id: 6,
      title: "5. Collecte de données",
      desc: "L'Utilisateur reconnaît et accepte que la Société puisse collecter et utiliser des données personnelles conformément à sa politique de confidentialité. L'Utilisateur est invité à consulter la politique de confidentialité de la Société pour en savoir plus sur les données collectées, leur utilisation et leur protection.",
    },
    {
      id: 7,
      title: "6. Limitation de responsabilité",
      desc: "Dans la mesure maximale autorisée par la loi applicable, la Société décline toute responsabilité pour tout dommage direct, indirect, accessoire, spécial, consécutif ou exemplaire découlant de l'utilisation ou de l'incapacité d'utiliser l'Application, même si la Société a été informée de la possibilité de tels dommages.",
    },
    {
      id: 8,
      title: "7. Modification du contrat",
      desc: "La Société se réserve le droit de modifier ce Contrat à tout moment, à sa seule discrétion. Les modifications entreront en vigueur dès leur publication dans l'Application. Il est de la responsabilité de l'Utilisateur de vérifier régulièrement les mises à jour du Contrat.",
    },
  ],
};

export const COLORS = ["#0768AE", "#029D40", "#F8F104", "#DC0123"];

export const InsurancePacks = [
  {
    id: 1,
    title: "Prestige Auto",
    desc: "Assurance automobile haut de gamme avec des garanties complètes adaptées à votre véhicule.",
    icon: require("../../assets/car.png"),
    type: "package",
    color: COLORS[0],
    bg: require("../../assets/carsbg.png"),
  },
  {
    id: 2,
    title: "Prestige Moto",
    desc: "Protection optimale pour votre deux-roues, que ce soit pour un usage personnel ou professionnel.",
    icon: require("../../assets/icons/moto.png"), // Assuming this exist or will be added
    type: "package",
    color: COLORS[1],
    bg: require("../../assets/bg-onWeb4.png"),
  },
  {
    id: 3,
    title: "MultiRisque Pro",
    desc: "Solutions d'assurance complètes pour les commerces, restaurants, hôtels et bars. soyez assuré(e) en toute sécurité.",
    icon: require("../../assets/iconmulti.png"),
    type: "package",
    color: COLORS[3],
    bg: require("../../assets/bg-onWeb3.png"),
  },
  // {
  //   id: 4,
  //   title: "Individuel Accident (IAC)",
  //   desc: "Couverture accidentelle forfaitaire pour vous protéger en cas d'imprévu.",
  //   icon: require("../../assets/icons/coverages/rcscolaire.png"), // Using similar icon for now
  //   type: "Produit",
  //   color: COLORS[3],
  //   bg: require("../../assets/carsbg.png"),
  // },
  {
    id: 4,
    title: "Assurance Santé + complémentaire AMO ",
    desc: `Couverture personnalisée à la suite de maladie ou d’accident en :
    •	Assurance santé « ordinaire » avec ou sans évacuation sanitaire à l’étranger et au taux de couverture choisi par l’assuré ;
    •	Complément AMO (prise en charge des 30% des soins non couverts par AMO).`,
    type: "Produit",
    icon: require("../../assets/icons/sante.png"),
    color: COLORS[0],
    coverage: [
      "Les garanties sont minutieusement choisies en fonction des besoins et du profil du prospect.",
    ],
    bg: require("../../assets/carsbg.png"),
  },

  {
    id: 5,
    title: "Assurance Assistance Voyage",
    desc: "Pour tous vos déplacements à l’étranger, Bénéficiez en cas d’urgence d’une assistance médicale et d’une prise en charge des frais liés aux pertes des documents d’identité (passeport, permis de conduire, carte d’identité), des bagages, rapatriement de corps, frais et honoraires d’avocats, etc.",
    icon: require("../../assets/icons/travel.png"),
    type: "Produit",
    clientType: 1,
    color: COLORS[1],
    coverage: [
      "Les garanties sont minutieusement choisies en fonction des besoins et du profil du prospect.",
    ],
    bg: require("../../assets/carsbg.png"),
  },
  {
    id: 6,
    title: "Assurance Transport de marchandises",
    desc: "Ne vous souciez plus du transport domestique  de vos marchandises selon la garantie souscrite. soyez assuré(e) en toute sécurité.",
    icon: require("../../assets/icons/transport.png"),
    type: "Produit",
    color: COLORS[3],
    coverage: [
      "Les garanties sont minutieusement choisies en fonction des besoins et du profil du prospect.",
    ],
    bg: require("../../assets/carsbg.png"),
  },
  {
    id: 7,
    title: "Assurance des risques Techniques",
    desc: "Nos offres d’assurance couvrent les risques susceptibles de se réaliser lors des travaux de construction ou après, sur les machines et équipements industriels, etc. ",
    icon: require("../../assets/icons/toolbox.png"),
    type: "Produit",
    color: COLORS[0],
    coverage: [
      "Les garanties sont minutieusement choisies en fonction des besoins et du profil du prospect.",
    ],
    bg: require("../../assets/carsbg.png"),
  },
  {
    id: 8,
    title: "RC SColaire",
    desc: "Assurance Responsabilité Civile Scolaire pour la tranquillité d’esprit des parents et des responsables d’établissements scolaires pour une meilleure protection des élèves et staffs.",
    type: "Produit",
    icon: require("../../assets/icons/coverages/rcscolaire.png"),
    color: COLORS[1],
    price: "",
    coverage: [
      "Combinaison spéciale de la Responsabilité Civile et l’Individuelle Accidents Corporels (IAC)",
    ],
    bg: require("../../assets/carsbg.png"),
    coverageLink: "https://cnarsugu.com/warranty/rcscolaire.pdf",
  },
];

const COVERAGES_AUTO = [
  // 1 CV
  {
    id: 1,
    type: "Tiers Simple",
    category: "1 CV",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "34 308 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 2,
    type: "Tiers Essentielle",
    category: "1 CV",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "44 308 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 3,
    type: "Tiers Étendue",
    category: "1 CV",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "54 308 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 4,
    type: "Tiers Confort",
    category: "1 CV",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "59 308 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  // 2 à 4 CV
  {
    id: 5,
    type: "Tiers Simple",
    category: "2 à 4 CV",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "40 144 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 6,
    type: "Tiers Essentielle",
    category: "2 à 4 CV",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "50 144 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 7,
    type: "Tiers Étendue",
    category: "2 à 4 CV",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "60 144 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 8,
    type: "Tiers Confort",
    category: "2 à 4 CV",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "65 144 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  // 5 à 7 CV
  {
    id: 9,
    type: "Tiers Simple",
    category: "5 à 7 CV",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "45 040 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 10,
    type: "Tiers Essentielle",
    category: "5 à 7 CV",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "55 040 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 11,
    type: "Tiers Étendue",
    category: "5 à 7 CV",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "65 040 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 12,
    type: "Tiers Confort",
    category: "5 à 7 CV",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "70 040 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  // 8 à 10 CV
  {
    id: 13,
    type: "Tiers Simple",
    category: "8 à 10 CV",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "56 747 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 14,
    type: "Tiers Essentielle",
    category: "8 à 10 CV",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "66 747 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 15,
    type: "Tiers Étendue",
    category: "8 à 10 CV",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "76 747 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 16,
    type: "Tiers Confort",
    category: "8 à 10 CV",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "81 747 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  // 11 à 16 CV
  {
    id: 17,
    type: "Tiers Simple",
    category: "11 à 16 CV",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "74 428 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 18,
    type: "Tiers Essentielle",
    category: "11 à 16 CV",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "84 428 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 19,
    type: "Tiers Étendue",
    category: "11 à 16 CV",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "94 428 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 20,
    type: "Tiers Confort",
    category: "11 à 16 CV",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "104 428 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  // 17 CV et +
  {
    id: 21,
    type: "Tiers Simple",
    category: "17 CV et +",
    description: "RC + DR + CEDEAO + Assistance+",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+"],
    price: "88 961 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 22,
    type: "Tiers Essentielle",
    category: "17 CV et +",
    description: "Tiers Simple + Incendie (IC)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)"],
    price: "98 961 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 23,
    type: "Tiers Étendue",
    category: "17 CV et +",
    description: "Essentielle + Vol à Main Armée (VAM)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)"],
    price: "108 961 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
  {
    id: 24,
    type: "Tiers Confort",
    category: "17 CV et +",
    description: "Étendue + Bris de Glace (BDG)",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Attestation CEDEAO", "Assistance+", "Incendie (IC)", "Vol à Main Armée (VAM)", "Bris de Glace (BDG)"],
    price: "118 961 FCFA",
    coverageLink: "https://cnarsugu.com/warranty/auto.pdf",
    icon: require("../../assets/car.png"),
  },
];

const COVERAGES_MOTO = [
  // Djakarta & Autres (< 2CV)
  {
    id: 1,
    type: "Tiers",
    category: "Moto < 2CV (Djakarta)",
    description: "RC + DR",
    coverage: ["Responsabilité Civile", "Défense - Recours"],
    price: "7 500 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
  {
    id: 2,
    type: "Essentielle",
    category: "Moto < 2CV (Djakarta)",
    description: "RC + DR + IAC",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Individuel Accident (IAC)"],
    price: "10 000 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
  // Grosse Cylindrée (>= 2CV)
  {
    id: 3,
    type: "Tiers",
    category: "Moto >= 2CV (Grosse Cylindrée)",
    description: "RC + DR",
    coverage: ["Responsabilité Civile", "Défense - Recours"],
    price: "35 000 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
  {
    id: 4,
    type: "Essentielle",
    category: "Moto >= 2CV (Grosse Cylindrée)",
    description: "RC + DR + IAC",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Individuel Accident (IAC)"],
    price: "37 500 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
  // Moto Taxi
  {
    id: 5,
    type: "Tiers",
    category: "Moto Taxi (Transport Public)",
    description: "RC + DR",
    coverage: ["Responsabilité Civile", "Défense - Recours"],
    price: "25 000 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
  {
    id: 6,
    type: "Essentielle",
    category: "Moto Taxi (Transport Public)",
    description: "RC + DR + IAC",
    coverage: ["Responsabilité Civile", "Défense - Recours", "Individuel Accident (IAC)"],
    price: "27 500 FCFA",
    icon: require("../../assets/icons/moto.png"),
  },
];

const COVERAGES_MULTI = [
  {
    id: 1,
    type: "Multirisque",
    category: "Boutiques",
    description: "Prix 50,000 FCFA (Capital coverage up to 36M)",
    coverage: [
      "Incendie : 36 000 000 (Franchise : Néant)",
      "Dommages Electriques : 500 000 (Franchise : 10%)",
      "Dégâts des Eaux : 250 000 (Franchise : 50 000)",
      "Bris de Glaces : 500 000 (Franchise : 10%)",
      "Vol : 2 000 000 (Franchise : 10% Min 100 000)",
      "RC Exploitation : 1 000 000 (Franchise : Néant)"
    ],
    price: "50 000 FCFA",
    icon: require("../../assets/icons/coverages/retailer.png"),
    clientType: 2,
    extraFields: ["shop"],
  },
  {
    id: 2,
    type: "Multirisque",
    category: "Restaurants",
    description: "Prix 80,000 FCFA (Capital coverage up to 27M)",
    coverage: [
      "Incendie : 27 000 000 (Franchise : Néant)",
      "Dommages Electriques : 1 000 000 (Franchise : 10% Min 80 000)",
      "Dégâts des Eaux : 1 000 000 (Franchise : 10%)",
      "Bris de Glaces : 1 000 000 (Franchise : 10% Min 50 000)",
      "Vol : 3 000 000 (Franchise : 10% Min 250 000)",
      "RC Exploitation : 15 000 000 (Franchise : Néant)"
    ],
    price: "80 000 FCFA",
    icon: require("../../assets/icons/coverages/cutlery.png"),
    clientType: 2,
    extraFields: ["activity"],
  },
  {
    id: 3,
    type: "Multirisque",
    category: "Hotels & Appart meublé",
    description: "Prix 155,000 FCFA (Capital coverage up to 75M)",
    coverage: [
      "Incendie : 75 000 000 (Franchise : Néant)",
      "Dommages Electriques : 1 000 000 (Franchise : 10% Min 80 000)",
      "Dégâts des Eaux : 3 000 000 (Franchise : 10% Min 150 000)",
      "Bris de Glaces : 2 000 000 (Franchise : 10% Min 75 000)",
      "Vol : 3 000 000 (Franchise : 10% Min 150 000)",
      "RC Exploitation : 10 000 000 (Franchise : Néant)"
    ],
    price: "155 000 FCFA",
    icon: require("../../assets/icons/coverages/hotel.png"),
    clientType: 2,
    extraFields: ["activity"],
  },
  {
    id: 4,
    type: "Multirisque",
    category: "Bars & Clubs",
    description: "Prix 200,000 FCFA (Capital coverage up to 40M)",
    coverage: [
      "Incendie : 40 000 000 (Franchise : Néant)",
      "Dommages Electriques : 1 000 000 (Franchise : 10% Min 80 000)",
      "Dégâts des Eaux : 3 000 000 (Franchise : 10% Min 250 000)",
      "Bris de Glaces : 2 000 000 (Franchise : 10% Min 75 000)",
      "Vol : 5 000 000 (Franchise : 10% Min 300 000)",
      "RC Exploitation : 10 000 000 (Franchise : Néant)"
    ],
    price: "200 000 FCFA",
    icon: require("../../assets/icons/coverages/cocktail.png"),
    clientType: 2,
    extraFields: ["activity"],
  },
];

const COVERAGES_IAC = [
  {
    id: 1,
    type: "Individuel Accident",
    category: "IAC Solo",
    description: "Prix Unique : 5 000 FCFA TTC",
    coverage: [
      "Décès : 500 000 FCFA",
      "Infirmité Permanente : 500 000 FCFA",
      "Frais de Traitement : 120 000 FCFA"
    ],
    price: "5 000 FCFA",
  }
];

export const COVERAGES = [COVERAGES_AUTO, COVERAGES_MOTO, COVERAGES_MULTI, COVERAGES_IAC];
